module.exports = __webpack_public_path__ + "static/media/dragon-sleeping.b13640c4.svg";